import colorMixin from '@/mixins/colors';

export default {
  mixins: [colorMixin],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    legendPosition: {
      type: String,
      default: 'top',
    },
    showLegend: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
    },
    titlePosition: {
      type: String,
      default: 'top',
    },
    colorCycle: {
      type: Array,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    tooltipsEnabled: {
      type: Boolean,
      default: true,
    },
    animationDuration: {
      type: Number,
      default: 1000,
    },
  },
  computed: {
    getChartData() {
      const safeData = Array.isArray(this.data) ? this.data : [];

      return {
        labels: safeData.map(s => s[0]),
        datasets: [
          {
            backgroundColor: safeData.map((s, i) => this.getColor(s[0], i)),
            data: safeData.map(s => s[1]),
          },
        ],
      };
    },

    getChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: !!this.title,
          position: this.titlePosition,
          text: this.title || '',
          padding: 0,
        },
        legend: {
          display: this.showLegend,
          position: this.legendPosition,
        },
        animation: {
          duration: this.animationDuration,
          onComplete: event => {
            if (this.animationComplete !== undefined) {
              this.animationComplete(event);
            }
          },
        },
        tooltips: {
          enabled: this.tooltipsEnabled,
        },
        onClick: (event, item) => this.$emit('onClick', [event, item]),
        ...this.options,
      };
    },
  },
  methods: {
    getColor(title, index) {
      const titleSwitcher = { male: 'Female', female: 'Male' };
      let titleColor = title;

      if (typeof title === 'string' && (title.toLowerCase() in titleSwitcher)) {
        titleColor = titleSwitcher[title.toLowerCase()];
      }

      if (!this.colorCycle) {
        return this.generateTitleColor(titleColor);
      }

      const colorsCount = this.colorCycle.length;
      return this.colorCycle[index % colorsCount];
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/charts/mixins/chartMixin.js